module.exports = __webpack_public_path__ + "static/img/Silicone Rubber for Extrusion.455f945.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/Silicone Rubber for Extrusion.jpg
// module id = sqUt
// module chunks = 1